import PropTypes from 'prop-types'
import Spinner from 'react-bootstrap/Spinner'

import styles from './RedireccionMP.module.css'

/**
 * Cortina de espera para las transiciones que terminan en Mercado Pago.
 *
 * Tapa la pantalla completa a propósito. Entre grabar la publicación y el `window.location.assign`
 * hay una request de red, y en ese hueco el formulario sigue vivo: en el asistente de publicar
 * queda además reseteado en el primer paso, como si no hubiera pasado nada. Un clic de más ahí manda
 * al vendedor a otra pantalla justo antes de que el navegador cambie de sitio, y la publicación
 * queda creada y sin pagar sin que él entienda por qué.
 *
 * @param {Object} props
 * @param {string} [props.mensaje] - Qué se está haciendo, en presente
 */
const RedireccionMP = ({ mensaje = 'Te estamos llevando a Mercado Pago' }) => (
  <div className={styles.cortina} role="alert" aria-busy="true">
    <div className={styles.caja}>
      <Spinner animation="border" role="status" aria-hidden="true" />
      <p className={styles.mensaje}>{mensaje}</p>
      <small className={styles.detalle}>No cierres ni recargues esta página.</small>
    </div>
  </div>
)

RedireccionMP.propTypes = {
  mensaje: PropTypes.string
}

export default RedireccionMP
